import React from "react";

function PrivacyPolicy() {
  return (
    <>
     {/* 👇 Component-scoped CSS override */}
      <style>{`
        /* Scope to this component only */
         ul, 
         ol {
          list-style: revert !important;        
          padding-left: 1.25rem !important;    
          margin-left: 0 !important;
        }
        ul { list-style-type: disc !important; }
         ol { list-style-type: decimal !important; }
         li { margin: 0.25rem 0; list-style-type: disc !important;} /* little spacing between items */
      `}</style>
   
    <div className="terms-conditions-page">
      <div className="bg-white !text-[#333] pb-10">
        {/* Policy Banner */}
        <div
          className="terms-banner relative w-full h-[300px] bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url('/images/about/termscondition.jpg')" }}
        >
          <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
            <h3 className="text-white text-6xl font-semibold">Privacy Policy</h3>
          </div>
        </div>

        {/* Policy Content */}
        <div className="container">
          <div className="text-left">
            <h1 className="text-4xl font-semibold my-3 text-[#333] font-sans py-3">
              Danny&apos;s Game Room — Privacy Policy
            </h1>
            <p className="mb-2">Last Updated: October, 2025</p>
            <p className="mb-4">
              At Danny&apos;s Game Room (&quot;we&quot;, &quot;our&quot;, &quot;us&quot;), we are committed to protecting your
              privacy and ensuring a safe online experience for all our users. This Privacy Policy outlines how we
              collect, use, disclose, and safeguard your information when you visit our website{" "}
              <a href="https://www.dannysgameroom.com" className="text-blue-600 underline">
                www.dannysgameroom.com
              </a>{" "}
              and engage with our gambling apps and games. By using our Website, you agree to the practices outlined
              in this policy.
            </p>

            <section>
              <h3 className="text-2xl font-semibold my-1 text-[#333] font-sans">1. Information We Collect</h3>
              <p className="mb-2">We collect the following types of information:</p>
              <h2 className="text-2xl font-semibold my-1 text-[#333] font-sans">a. Personal Information</h2>
              <p className="mb-2">When you register for an account, make a transaction, or interact with us, we may collect:</p>
              <ul className="mb-4">
                <li>Name</li>
                <li >Email address</li>
                <li >Phone number</li>
                <li >Date of birth (to verify age)</li>
                <li >Payment information (credit/debit card details, billing address)</li>
                <li >Account username and password</li>
                <li >Location data (IP address, GPS)</li>
              </ul>
              <h4 className="text-2xl font-semibold my-1 text-[#333] font-sans">b. Non-Personal Information</h4>
              <p className="mb-2">We may also collect non-personal information, such as:</p>
              <ul className="mb-4">
                <li>Browser type and version</li>
                <li>Operating system details</li>
                <li>Device type</li>
                <li>Pages visited on the Website</li>
                <li>Time and date of visits</li>
                <li>Referring website and search terms</li>
              </ul>
            </section>

            <section>
              <h3 className="text-2xl font-semibold my-3 text-[#333] font-sans py-3">2. How We Use Your Information</h3>
              <ul className="mb-4">
                <li>To provide and manage your account and access to our games</li>
                <li>To process transactions and payments</li>
                <li>To communicate with you about account updates, promotions, or customer support</li>
                <li>To personalize your experience and improve our Website</li>
                <li>To comply with legal requirements (age verification, anti-money laundering)</li>
                <li>To send promotional offers, newsletters, and marketing communications (with your consent)</li>
                <li>To detect, prevent, or investigate illegal activities, fraud, or security breaches</li>
              </ul>
            </section>

            <section>
              <h3 className="text-2xl font-semibold my-3 text-[#333] font-sans py-3">
                3. Cookies and Tracking Technologies
              </h3>
              <p className="mb-2">
                We use cookies and similar technologies (such as web beacons and pixel tags) to enhance your experience,
                analyze trends, track movement around the Website, and gather demographic information. Cookies are small
                data files stored on your device that help us remember your preferences and improve functionality. You
                can manage cookie preferences via your browser settings.
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold my-3 text-[#333] font-sans py-3">4. Sharing Your Information</h3>
              <p className="mb-2">
                We do not sell, rent, or share your personal information with third parties for marketing purposes without
                your consent. We may share information in the following situations:
              </p>
              <ul className="mb-4">
                <li>
                  <strong>Service Providers:</strong> With third-party vendors who assist in operating our Website and
                  providing services (e.g., payment processors, customer support, marketing agencies).
                </li>
                <li>
                  <strong>Legal Compliance:</strong> As required by law or in response to a valid legal request (e.g.,
                  subpoena, court order).
                </li>
                <li>
                  <strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your
                  information may be transferred to the new owner or entity.
                </li>
              </ul>
            </section>

            <section>
              <h3 className="text-2xl font-semibold my-3 text-[#333] font-sans py-3">5. Security of Your Information</h3>
              <p className="mb-2">
                We implement reasonable security measures to protect your personal information from unauthorized access,
                alteration, or destruction, including encryption, firewalls, and secure payment processing. However, no
                security system is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold my-3 text-[#333] font-sans py-3">6. Your Rights and Choices</h3>
              <ul className="mb-4">
                <li>
                  <strong>Access and Correction:</strong> You may request access to or correction of personal data we
                  hold about you.
                </li>
                <li>
                  <strong>Deletion:</strong> You can request deletion of your personal data, subject to legal and
                  contractual obligations.
                </li>
                <li>
                  <strong>Opt-Out:</strong> You can opt out of marketing communications at any time by clicking
                  &quot;unsubscribe&quot; or by contacting us directly.
                </li>
              </ul>
              <p className="mb-2">If you wish to exercise any of these rights, please contact us at Danny’s Chat Support.</p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold my-3 text-[#333] font-sans py-3">7. Age Restrictions</h3>
              <p className="mb-2">
                Our Website and services are intended for users who are at least 18 years old (or the legal age for
                gambling in your jurisdiction, whichever is higher). We do not knowingly collect personal information
                from individuals under the legal gambling age. If we learn that we have collected personal information
                from a minor, we will take steps to delete that information.
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold my-3 text-[#333] font-sans py-3">8. Third-Party Links</h3>
              <p className="mb-2">
                Our Website may contain links to third-party websites that are not operated by us. We are not responsible
                for the privacy practices of these third-party sites. We encourage you to review their privacy policies
                before providing any personal information.
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold my-3 text-[#333] font-sans py-3">9. Changes to This Privacy Policy</h3>
              <p className="mb-2">
                We reserve the right to update or modify this Privacy Policy at any time. Any changes will be posted on
                this page with an updated &quot;Last Updated&quot; date. Your continued use of the Website after the
                posting of changes constitutes your acceptance of those changes.
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold my-3 text-[#333] font-sans py-3">10. Contact Us</h3>
              <p className="mb-2">
                If you have any questions or concerns about this Privacy Policy, or if you wish to exercise any of your
                rights, please contact us at:
              </p>
              <p className="mb-6">Danny&apos;s Chat Support</p>
            </section>
          </div>
        </div>
      </div>
    </div>
     </>
  );
}

export default PrivacyPolicy;
